import { Modal, Table } from "antd";
import { DocumentosModal } from "../../admin/casos/DocumentosModal";

export const ModalDocumentos = () => {

    return (
        <DocumentosModal junior={true} />
    );

}